import { render } from "./BaseDatepicker.vue?vue&type=template&id=fc3036ca&scoped=true"
import script from "./BaseDatepicker.vue?vue&type=script&lang=js"
export * from "./BaseDatepicker.vue?vue&type=script&lang=js"

import "./BaseDatepicker.vue?vue&type=style&index=0&id=fc3036ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3036ca"]])

export default __exports__